var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_has.js
// module id = ../../../../core-js/library/modules/_has.js
// module chunks = 7